import { CreateTemplateButton } from '../../../features/templates';

import { Button, Icon } from '../../../shared/ui';

import { IconMap } from '../../../shared/sprite';
import { useTemplatesActions } from '../hooks';

export const TemplatesActions = () => {
  const {
    handleCreateTemplate,
    handleClickBrowseTemplates,
    createPageIsLoading,
    createBlankTemplateIsLoading,
  } = useTemplatesActions();

  return (
    <div className="flex flex-nowrap items-center gap-3 sm:hidden">
      <Button
        variant="text"
        color="secondary"
        size="md"
        onClick={handleClickBrowseTemplates}
        loading={createPageIsLoading}
        className="!font-semibold shadow-xs"
      >
        Browse templates
      </Button>
      <CreateTemplateButton listStyles="w-41" onSelect={handleCreateTemplate}>
        <Button
          variant="text"
          color="primary"
          size="md"
          className="!font-semibold shadow-xs"
          loading={createBlankTemplateIsLoading}
        >
          <Icon glyph={IconMap.TemplatesPlus} width={20} className="mr-1" />
          Create template
        </Button>
      </CreateTemplateButton>
    </div>
  );
};
